export default {
  head_scripts: {
    title: 'Head-scripts',
  },
  body_noscripts: {
    title: 'Body-noscripts',
    description: 'Indsæt kode lige efter åbning af body',
  },
  google_site_verification: {
    title: 'Google Site Verification',
    label: 'Google-bekræftelseskode for websted',
  },
  buttons: {
    save: 'Gem',
  },
};
